// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2qnbR","buttons":"SendReceipts_buttons__foV0A","email":"SendReceipts_email__JG7Wp","bookApptTitle":"SendReceipts_bookApptTitle__3VulL"};